import { QueryExpressionParserService, ValueAdapter, SimpleChipExpression } from '@nrwl/query-emitter';
import { SupportedSearchKeywords } from '../../providers/atweb-query-expression-parser.service';
import { cloneDeep } from 'lodash';

export class FilterAnomalyAdapter extends ValueAdapter {
  keywordsToAnomalyTerms: Map<string, string> = new Map();
  constructor(private readonly queryBuilder: QueryExpressionParserService) {
    super();
    // those terms (app, anomaly_ip, ...) shall be matched against terms in data.models.json
    this.keywordsToAnomalyTerms.set(SupportedSearchKeywords.App, 'app');
    this.keywordsToAnomalyTerms.set(SupportedSearchKeywords.Server, 'anomaly_ip');
    this.keywordsToAnomalyTerms.set(SupportedSearchKeywords.Site, 'site');
    this.keywordsToAnomalyTerms.set(SupportedSearchKeywords.User, 'user');
  }

  processValue(value): any {
    if (!value) {
      return '';
    }
    if (!this.isChipExpressionBased(value)) {
      return value;
    }
    // and only then attempt converting value to desired format
    const result = this.build(value as SimpleChipExpression[]);
    return result;
  }

  build(value: SimpleChipExpression[]): string {
    const copy = cloneDeep(value);
    // step one. replace UI-keywords with db field names
    copy.forEach(expression => {
      this.replaceName(expression);
    });
    return this.queryBuilder.toExpression(copy);
  }

  replaceName(exp: SimpleChipExpression) {
    const match = this.keywordsToAnomalyTerms.get(exp.keyword);
    if (!match) {
      return; // no match - we dont need to translate the keyword
    }
    exp.keyword = match;
  }
}
